module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Regular.9bd7b9e.woff2";